// import 'babel-polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import AppearanceSelect from './AppearanceSelect';
import Advert from './Advert';
import Articles from './Articles';
import Article from './Article';
import ArticleSearch from './ArticleSearch';
import Superbanner from './Superbanner';
import Menu from './Menu';
import Nav from './Nav';
import Insider from './Insider';
import Guestwriter from './Guestwriter';
import Authors from './Authors';
import Shegallery from './Shegallery';
import Splash from './Splash';
import TopTags from "./TopTags";
import SheComHLogo from "./SheComHorizontalLogo";
import FTopTags from "./FTopTags";
import TrendingPic from "./TrendingPic";
import Voting from "./Voting";
import Vindex from "./Vindex";
import VirtualPageView from './VirtualPageView';
import BVoting from "./BVoting";
import BABanner from "./BABanner";
import BVindex from "./BVindex";
import BASVindex from "./BASVindex";
import SMAVindex from "./SMAVindex";
import IGBlock from "./IGBlock";
import CritiquesHome from "./CritiquesHome";


let baseURL = document.querySelector('meta[name="baseURL"]').content;
let basePATH = document.querySelector('meta[name="basePATH"]').content;
let catId = document.querySelector('meta[name="catId"]').content;
let catName = document.querySelector('meta[name="category"]')? document.querySelector('meta[name="category"]').content : '';
let postId = document.querySelector('meta[name="postId"]').content;
let theme = document.querySelector('meta[name="theme"]') ? document.querySelector('meta[name="theme"]').content : basePATH.replace(baseURL+'/wp-content/themes/','');
let author = document.querySelector('meta[name="author"]').content;
let authors = document.querySelector('meta[name="authors"]').content;
let guestwriters = (theme == 'she.com') ? document.querySelector('meta[name="guestwriters"]').content : '';
let page = document.querySelector('meta[name="page"]').content;
let subcat = document.querySelector('meta[name="subcat"]').content;
let apiLabel = document.querySelector('meta[name="apiLabel"]').content;
let menuData = [];

function trimThemeName(tmpCurTheme){
	let tmpTheme = tmpCurTheme;

	if(tmpTheme.indexOf('blog.she.com')!=-1){
		tmpTheme = tmpTheme.replace('.home','');
	}

	if(window.location.href.indexOf('facelift.she.com')!=-1){
        tmpTheme = 'facelift.she.com'
	}

	return tmpTheme;
}

if (document.getElementById('appearance-select')) {
	ReactDOM.render(<AppearanceSelect page={page} />, document.getElementById('appearance-select'));
}

if(document.getElementById('insider')){
	ReactDOM.render(
	  <Insider baseurl={baseURL} theme={theme} authors={authors} />,
	  document.getElementById('insider')
	);
}
if(document.getElementById('guestwriter')){
	ReactDOM.render(
	  <Guestwriter baseurl={baseURL} theme={theme} authors={guestwriters} />,
	  document.getElementById('guestwriter')
	);
}

if(document.getElementById('pro-blogger')){
	let elm = document.getElementById('pro-blogger');

	ReactDOM.render(
	  <Authors baseurl={baseURL} theme={theme} wrap={elm} showall={true} api={'getProBloggers'} />,
	  document.getElementById('pro-blogger')
	);
}

if(document.getElementById('hottest-blogger')){
	let elm = document.getElementById('hottest-blogger');

	ReactDOM.render(
	  <Authors baseurl={baseURL} theme={theme} wrap={elm} showall={true} api={'getHottestBloggers'} />,
	  document.getElementById('hottest-blogger')
	);
}

if(document.getElementById('assigned-authors') && authors!=''){
	let elm = document.getElementById('assigned-authors');

	ReactDOM.render(
	  <Authors baseurl={baseURL} theme={theme} authors={authors} wrap={elm} />,
	  document.getElementById('assigned-authors')
	);
}

if(document.getElementById('splash-wrapper')){
	ReactDOM.render(
	  <Splash baseurl={baseURL} theme={theme} />,
	  document.getElementById('splash-wrapper')
	);
}

if(document.getElementById('superbanner')){
	const element = document.getElementById('superbanner');
	const props = JSON.parse(element.dataset.props);
	ReactDOM.render(<Superbanner theme={theme} items={props.items} />, element);
}

if(document.getElementById('mevote')){
	if (document.getElementById('mevote').getAttribute('vid')==null){
		fetch('/wp-json/she-rest-api/getRanVote/',{
			method:"POST",
		}).then(function(res){
			return res.json();
		}).then(function(response){
			ReactDOM.render(
				<Voting  vid={response}  />,
				document.getElementById('mevote')
			);


		}).catch(function(error){
			console.error(error);
		});
	}else{
		ReactDOM.render(
			<Voting  vid={document.getElementById('mevote').getAttribute('vid')}  />,
			document.getElementById('mevote')
		);
	}


}

if(document.getElementById('v-index')){
	ReactDOM.render(
		<Vindex />,
		document.getElementById('v-index')
	);

}

if(document.getElementById('bablock')){
	ReactDOM.render(
		<BVoting  vid={401332} />,
		document.getElementById('bablock')
	);

}

if(document.getElementById('basuperbanner')){
	var year = document.getElementById('basuperbanner').dataset.year;
	ReactDOM.render(
		<BABanner year={{year}}/>,
		document.getElementById('basuperbanner')
	);

}

if(document.getElementById('ba-vote-blk')){
	var year = document.getElementById('ba-vote-blk').dataset.year;
	var month = document.getElementById('ba-vote-blk').dataset.month;
	var dkey = document.getElementById('ba-vote-blk').dataset.dkey;
	var ss = document.getElementById('ba-vote-blk').dataset.ss;
	var fw = document.getElementById('ba-vote-blk').dataset.fw;
	ReactDOM.render(
		<BVindex year={year} dkey={dkey} ss={ss} fw={fw} month={month}/>,
		document.getElementById('ba-vote-blk')
	);

}



if(document.getElementById('ba-vote-blk-sessions-makeup')){
	var year = document.getElementById('ba-vote-blk-sessions-makeup').dataset.year;
	var month = document.getElementById('ba-vote-blk-sessions-makeup').dataset.month;
	var dkey = document.getElementById('ba-vote-blk-sessions-makeup').dataset.dkey;
	var ss = document.getElementById('ba-vote-blk-sessions-makeup').dataset.ss;
	var fw = document.getElementById('ba-vote-blk-sessions-makeup').dataset.fw;
	var role = document.getElementById('ba-vote-blk-sessions-makeup').dataset.role;
	var code = document.getElementById('ba-vote-blk-sessions-makeup').dataset.code;
	var sessionid = document.getElementById('ba-vote-blk-sessions-makeup').dataset.session;
	ReactDOM.render(
		<BASVindex year={year} dkey={dkey} ss={ss} fw={fw} month={month} role={role} code={code} sessionid={sessionid}/>,
		document.getElementById('ba-vote-blk-sessions-makeup')
	);

}
if(document.getElementById('ba-vote-blk-sessions-cosmetic')){
	var year = document.getElementById('ba-vote-blk-sessions-cosmetic').dataset.year;
	var month = document.getElementById('ba-vote-blk-sessions-cosmetic').dataset.month;
	var dkey = document.getElementById('ba-vote-blk-sessions-cosmetic').dataset.dkey;
	var ss = document.getElementById('ba-vote-blk-sessions-cosmetic').dataset.ss;
	var fw = document.getElementById('ba-vote-blk-sessions-cosmetic').dataset.fw;
	var role = document.getElementById('ba-vote-blk-sessions-cosmetic').dataset.role;
	var code = document.getElementById('ba-vote-blk-sessions-cosmetic').dataset.code;
	var sessionid = document.getElementById('ba-vote-blk-sessions-cosmetic').dataset.session;
	ReactDOM.render(
		<BASVindex year={year} dkey={dkey} ss={ss} fw={fw} month={month} role={role} code={code} sessionid={sessionid}/>,
		document.getElementById('ba-vote-blk-sessions-cosmetic')
	);

}

if(document.getElementById('sma-vote-blk')){
	var year = document.getElementById('sma-vote-blk').dataset.year;
	var role = document.getElementById('sma-vote-blk').dataset.role;
	var code = document.getElementById('sma-vote-blk').dataset.code;
	ReactDOM.render(
		<SMAVindex year={year} role={role} code={code}/>,
		document.getElementById('sma-vote-blk')
	);

}



if(document.getElementById('article-list')){
	let tmpTheme = trimThemeName(theme);
	let replaceTitle = document.getElementById('article-list').dataset;

	if(replaceTitle.hasOwnProperty('title') && replaceTitle.title != ''){
		replaceTitle = replaceTitle.title;
	}else{
		replaceTitle = 'highlights';
	}

	ReactDOM.render(
		<Articles baseurl={baseURL} theme={tmpTheme} author={author}  catId={catId} subcat={subcat} section={page} apiLabel={apiLabel} replaceTitle={replaceTitle} postId={postId}/>,
		document.getElementById('article-list')
	);
}

if(document.getElementById('article-search-list')){
    let tmpTheme = trimThemeName(theme);
    let replaceTitle = document.getElementById('article-search-list').dataset;

    if(replaceTitle.hasOwnProperty('title') && replaceTitle.title != ''){
        replaceTitle = replaceTitle.title;
    }else{
        replaceTitle = 'highlights';
    }

	ReactDOM.render(
		<ArticleSearch baseurl={baseURL} theme={tmpTheme} author={author}  catId={catId} subcat={subcat} section={page} apiLabel={apiLabel} replaceTitle={replaceTitle} postId={postId}/>,
		document.getElementById('article-search-list')
	);
}

if(document.getElementById('ad_300x250')){
	ReactDOM.render(<Advert position="loopMediumRectangle" />, document.getElementById('ad_300x250'));
}

if(document.getElementById('leaderboard')){
	ReactDOM.render(<Advert position="firstLeaderboard" />, document.getElementById('leaderboard'));
}

if(document.getElementById('top-navigation')){
	let catSlugAttempt = document.querySelector('body').classList[0];
	if(document.getElementById('moreig')){
		catSlugAttempt ='instagram';
		catName ='instagram';
	}
	catSlugAttempt = ['beauty', 'fashion', 'entertainment', 'hair', 'health', 'living', 'love', 'babygrowth', 'babymetabolism', 'celeb-family', 'fashion-and-beauty', 'hot-topics', 'lifestyle', 'motherhood', 'nestlemomme', 'she-promotes', 'celeb', 'guides', 'secret-talk-2', 'style-beauty', 'tools', 'wife-able', 'utility-list', 'instagram'].includes(catSlugAttempt) ? catSlugAttempt : null;
	console.log(catName);
	ReactDOM.render(<Nav catSlug={catSlugAttempt} catName={catName} page={page} pageId={postId} theme={theme} />, document.getElementById('top-navigation'));
}
if(document.getElementById('botbgdiv')){
	var classlist = document.querySelector('body').classList;

	switch (classlist[0]) {
		// she.com
		case 'beauty': var color = '#6D4840'; break;
		case 'fashion': var color = '#6B1E17'; break;
		case 'entertainment': var color = '#4A4252'; break;
		case 'hair': var color = '#614737'; break;
		case 'health': var color = '#596247'; break;
		case 'living': var color = '#917736'; break;
		case 'love': var color = '#6A372D'; break;

		// shemom.com
		case 'babygrowth': var color = '#bd8f86'; break;
		case 'babymetabolism': var color = '#966e40'; break;
		case 'celeb-family': var color = '#e7d6d3'; break;
		case 'fashion-and-beauty': var color = '#4f433f'; break;
		case 'hot-topics': var color = '#d9c0bb'; break;
		case 'lifestyle': var color = '#957773'; break;
		case 'motherhood': var color = '#a97f7d'; break;
		case 'nestlemomme': var color = '#43388a'; break;
		case 'she-promotes': var color = '#bd8f86'; break;

		// brides.she.com
		case 'celeb': var color = '#6D826D'; break;
		case 'guides': var color = '#233E1C'; break;
		case 'secret-talk-2': var color = '#9EAB9E'; break;
		case 'style-beauty': var color = '#859197'; break;
		case 'tools': var color = '#658187'; break;
		case 'wife-able': var color = '#8F989A'; break;
		case 'utility-list': var color = '#ffffff'; break;

		default: var color = '#EEEBEB'; break;
	}
	if (document.querySelector('body').classList.contains('xmas')){
		var color = '#6B1E17';
	}
	if (document.querySelector('.viutv') != null){
		var color = '#FFFFFF';
	}

	ReactDOM.render(<SheComHLogo color={color} theme={theme} />, document.getElementById('botbgdiv'));
}

if(document.getElementById('fixed-menu')){
	ReactDOM.render(
		<Menu baseurl={baseURL} theme={theme} catId={catId} postId={postId}/>,
		document.getElementById('fixed-menu')
	);
}

if(document.getElementById('article-content')){
	let tmpTheme = trimThemeName(theme);
	if (document.getElementById('article-content').classList.contains('grouping')){
		var grouping = true;
	}else{
		var grouping = false;
	}
	ReactDOM.render(
	  <Article baseurl={baseURL} theme={tmpTheme} catId={catId} postId={postId} section={page} grouping ={grouping}/>,
	  document.getElementById('article-content')
	);
}

if(document.getElementById('blogger-tags-box')){
	let tagmore = document.querySelector('.blogger-tag-more');
	let tagbox = document.querySelector('.blogger-tags-box');

	tagmore.onclick = function(){
		let tagmoreSpan = document.querySelectorAll('.blogger-tag-more span');
		if(tagbox.className.indexOf('showall')==-1){
			tagbox.className = tagbox.className + ' showall';
		}else{
			tagbox.className = tagbox.className.replace(' showall','');
		}

		for(let i=0; i<tagmoreSpan.length;i++){
			if(tagmoreSpan[i].className==''){
				tagmoreSpan[i].className = 'active';
			}else{
				tagmoreSpan[i].className = '';
			}
		}
	};
}

if(document.getElementById('trendpic')){
	ReactDOM.render(
		<TrendingPic theme={theme} page= {0}/>,

		document.getElementById('trendpic')
	);
}

if(document.getElementById('critiques-home')){
	ReactDOM.render(
		<CritiquesHome />,
		document.getElementById('critiques-home')
	);
}

if(document.getElementById('moreig')){
	var channel = document.getElementById('moreig').dataset.channel;
	ReactDOM.render(
		<IGBlock channel={channel} />,
		document.getElementById('moreig')
	);
}

/* Tag Cloud (for PHP page) */
// page = home/category/single?
// catName) = category parent name
let isMobile = (navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i) || window.innerWidth <= 767);
let popularTag = (document.getElementById('popular-tag') && document.getElementById('popular-tag').dataset) ? document.getElementById('popular-tag').dataset.tags : ((document.getElementById('popular-tag-mobile-top') && document.getElementById('popular-tag-mobile-top').dataset) ? document.getElementById('popular-tag-mobile-top').dataset.tags : '');
let tagList = popularTag? JSON.parse(popularTag) : [];

if (page == 'home' || page == 'category' || page == 'single') {
	if (isMobile) {
		// if (document.getElementById('popular-tag-mobile-top')) {
		// 	ReactDOM.render(
		// 		<TopTags theme={trimThemeName(theme)} page={page} position={'top'} catName={catName} tagList={tagList}/>,
		// 		document.getElementById('popular-tag-mobile-top')
		// 	);
		// }
		document.querySelectorAll('.popular-tag-mobile').forEach((tag_mobile, index) =>
			ReactDOM.render(
				<TopTags theme={trimThemeName(theme)} page={page} position={'side'} catName={catName} tagList={tagList}/>,
				tag_mobile)
		);
	} else {
		const TagComponent = ['home', 'category'].includes(page) ? FTopTags : TopTags;
		document.querySelectorAll('.popular-tag-desktop').forEach((tag_desktop, index) =>
			ReactDOM.render(<TagComponent theme={trimThemeName(theme)} page={page} position={'side'} catName={catName} tagList={tagList}/>, tag_desktop)
		);

		// Tag element which should always rendered as a FTopTags
		document.querySelectorAll('.popular-full-width-tag-desktop').forEach((tag_desktop, index) =>
			ReactDOM.render(<FTopTags theme={trimThemeName(theme)} page={page} position={'side'} catName={catName} tagList={tagList}/>, tag_desktop)
		);
	}
}


/**
 * Virtual page view should only be rendered after window's `load` event is
 * being triggered.
 */
let virtualPageViewTimeout;
function renderVirtualPageViewComponent () {
	/**
	 * Append an element to body instead of updating the server-side-rendered HTML
	 * view
	 */
	if (typeof virtualPageViewTimeout !== "number") { return; }
	window.clearTimeout(virtualPageViewTimeout);
	virtualPageViewTimeout = null;
	const virtualPageViewNode = document.createElement("div");
	virtualPageViewNode.setAttribute("id", "virtual-page-view-node");
	document.body.appendChild(virtualPageViewNode);
	ReactDOM.render(<VirtualPageView />, virtualPageViewNode);
}
virtualPageViewTimeout = window.setTimeout(renderVirtualPageViewComponent, 5000);
window.addEventListener("load", renderVirtualPageViewComponent);



// WEBPACK FOOTER //
// ./src/index.js